import {
  ChangeDetectorRef,
  Component, EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit, Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  DxButtonModule,
  DxHtmlEditorComponent,
  DxHtmlEditorModule, DxLoadIndicatorModule, DxLoadPanelModule,
  DxPopupModule,
  DxTooltipModule
} from "devextreme-angular";
import {MicToJsonService} from "./mic-to-json.service";
import {Subscription} from "rxjs";
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'app-mic-to-json-button',
  standalone: true,
  imports: [CommonModule, DxButtonModule, DxTooltipModule, DxPopupModule, DxHtmlEditorModule, DxLoadIndicatorModule, DxLoadPanelModule],
  templateUrl: './mic-to-json-button.component.html',
  styleUrls: ['./mic-to-json-button.component.scss']
})
export class MicToJsonButtonComponent implements OnInit, OnDestroy, OnChanges {
  @Input() area?: string;
  @Input() fileName: string | undefined;
  @Input() generateDocument: boolean = true;
  @Input() json: any;
  @Input() questions: string[] = [];
  @Output() jsonAvailable: EventEmitter<object> = new EventEmitter<object>();
  @ViewChild('editor', {static: false}) editor: DxHtmlEditorComponent | undefined;
  isPopUpVisible = false;

  private detectionSubscription?: Subscription;
  private jsonParsingSubscription?: Subscription;
  private transcriptionAvailableSubscription?: Subscription;

  constructor(public service: MicToJsonService, private changesDetector: ChangeDetectorRef) {
  }

  ngOnDestroy(): void {
    this.detectionSubscription?.unsubscribe();
    this.transcriptionAvailableSubscription?.unsubscribe();
  }

  ngOnInit(): void {
    this.detectionSubscription = this.service.mediaService.Changes.subscribe(() => {
      this.changesDetector.detectChanges();
    });
    this.transcriptionAvailableSubscription = this.service.TranscriptionAvailable?.subscribe((value) => {
      if (value != '')
        this.isPopUpVisible = true;
      this.changesDetector.detectChanges();
      this.editor?.instance?.option('value', value);
      this.changesDetector.detectChanges();
    });
    this.jsonParsingSubscription = this.service.JsonAvailable?.subscribe((value) => {
      this.jsonAvailable.emit(value);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.area && changes.area.currentValue) {
      this.service.Area = changes.area.currentValue;
    }

    if (changes.fileName && changes.fileName.currentValue) {
      this.service.FileName = changes.fileName.currentValue;
    }

    if (changes.json && changes.json.currentValue) {
      this.service.JsonObject = changes.json.currentValue;
    }

    if (changes.questions && changes.questions.currentValue) {
      this.service.Questions = changes.questions.currentValue;
    }
  }

  get IsEnabled(): boolean {
    return environment.aiCommands.areas.includes(this.area ?? '');
  }

  public async close(discard: boolean = true) {
    this.isPopUpVisible = false;
    if (discard) {
      await this.service.mediaService.reset();
      this.service.TranscriptionAvailable.next('');
    } else {
      const value = this.editor?.instance.option('value');
      await this.service.generateJsonFromTranscript(this.generateDocument, value);
    }
  }
}
